const DateUtils = {
    formatHour(dateString) {
        const date = new Date(dateString);
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
    },

    timeFromNow(dateString) {
        const date = new Date(dateString);
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);

        const intervals = [
            { label: "year", seconds: 31536000 },
            { label: "month", seconds: 2592000 },
            { label: "day", seconds: 86400 },
            { label: "hour", seconds: 3600 },
            { label: "minute", seconds: 60 },
            { label: "second", seconds: 1 },
        ];

        for (const interval of intervals) {
            const count = Math.floor(diffInSeconds / interval.seconds);
            if (count > 0) {
                return `${count} ${interval.label}${count !== 1 ? "s" : ""} ago`;
            }
        }

        return "just now";
    },

    formatDateTime(dateString, locale = 'tr-TR') {
        const date = new Date(dateString);
        const options = { year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric" };
        return date.toLocaleString(locale, options);
    },

    initializeLocale(locale) {
        return locale;
    },

    updateLocale(locale) {
        if (currentLocale !== locale) {
            currentLocale = locale;
        }
        return currentLocale;
    }
};

let currentLocale = Intl.DateTimeFormat().resolvedOptions().locale;

module.exports = DateUtils;



// WEBPACK FOOTER //
// ./src/utils/DateUtil.js